
namespace TabAurous.SalesOrder{

    @Serenity.Decorators.registerClass()
    export class OrderItemsForPurchaseGrid extends _Ext.GridBase<SalesOrderItemsRow, any> {
        protected getColumnsKey() { return 'SalesOrder.SalesOrderItems'; }
        protected getDialogType() { return SalesOrderItemsDialog; }
        protected getIdProperty() { return SalesOrderItemsRow.idProperty; }
        protected getInsertPermission() { return SalesOrderItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesOrderItemsRow.localTextPrefix; }
        protected getService() { return OrderItemsForPurchaseService.baseUrl; }

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {}; 
        protected getColumns() {

            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };
        constructor(container: JQuery, options) {
            super(container, options);

            (this.view.params as TransactionRequest).PartyId = options.GridFilters.PartyId;
            (this.view.params as TransactionRequest).InStock = options.GridFilters.InStock;
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): SalesOrderItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }

    } 
}